import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AjaxService } from '../services/ajax.service';

@Component({
  selector: 'app-enrollment',
  templateUrl: './enrollment.component.html',
  styleUrls: ['./enrollment.component.scss']
})
export class EnrollmentComponent implements OnInit {

  resources: any[] = []
  constructor(private _ajaxService: AjaxService, private _router: Router) { }

  ngOnInit(): void {
    this.getResources()
  }

  getResources() {
    const request = {
      parentId : 4
    } 
    this._ajaxService.post('dashboard/getResourcesOnParentId', request).then((response: any) => {
      if (response.statusCode == 200) {
        this.resources = response.data;
      }
    });
  }

  handleRedirect(path : string) {
    if (path != '' && path != null && path != undefined) {
      if (path.startsWith('/') || !path.startsWith('http')) {
        this._router.navigate([path])
      } else {
        window.open(path, "_blank");
      }
    }
  }
}
